export class Cookie {
    static set(name, value, days) {
        var expires = "expires=Fri, 31 Dec 9999 23:59:59 GMT;";
        if (days != undefined) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + value + "; " + expires + "; path=/";
    }
    static get(name) {
        let cname = name + "=";
        let items = document.cookie.split(";");
        for (let i = 0; i < items.length; i++) {
            let item = items[i];
            while (item.charAt(0) == ' ') {
                item = item.substring(1, item.length);
            }
            if (item.indexOf(cname) == 0) {
                return item.substring(cname.length, item.length);
            }
        }
        return "";
    }
    static delete(name) {
        let date = new Date();
        date.setDate(-1);
        let value = "";
        document.cookie = name + "=" + value + "; expires=" + date.toUTCString() + "; path=/";
    }
}
